/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Creationdate2Inputs */

const id_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Pembuatan`)
};

const ms_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Penciptaan`)
};

const da_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelsesdato`)
};

const de_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellungsdatum`)
};

const en_us2_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation Date`)
};

const es_es2_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const es_mx2_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const fil_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Paggawa`)
};

const fr_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de création`)
};

const it_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di creazione`)
};

const hu_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozás dátuma`)
};

const nl_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmaakdatum`)
};

const no_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettelsesdato`)
};

const pl_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data utworzenia`)
};

const pt_br2_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const pt_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const ro_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data creării`)
};

const fi_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontipäivä`)
};

const sv_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapelsedatum`)
};

const vi_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

const tr_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma Tarihi`)
};

const cs_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vytvoření`)
};

const bg_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на създаване`)
};

const ru_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата создания`)
};

const uk_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата створення`)
};

const ar_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण तिथि`)
};

const th_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่สร้าง`)
};

const ja_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建日期`)
};

const zh_hant1_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立日期`)
};

const ko_offerdetail_table_creationdate2 = /** @type {(inputs: Offerdetail_Table_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 날짜`)
};

/**
* | output |
* | --- |
* | "Creation Date" |
*
* @param {Offerdetail_Table_Creationdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_creationdate2 = /** @type {((inputs?: Offerdetail_Table_Creationdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Creationdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_creationdate2(inputs)
	if (locale === "ms") return ms_offerdetail_table_creationdate2(inputs)
	if (locale === "da") return da_offerdetail_table_creationdate2(inputs)
	if (locale === "de") return de_offerdetail_table_creationdate2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_creationdate2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_creationdate2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_creationdate2(inputs)
	if (locale === "fil") return fil_offerdetail_table_creationdate2(inputs)
	if (locale === "fr") return fr_offerdetail_table_creationdate2(inputs)
	if (locale === "it") return it_offerdetail_table_creationdate2(inputs)
	if (locale === "hu") return hu_offerdetail_table_creationdate2(inputs)
	if (locale === "nl") return nl_offerdetail_table_creationdate2(inputs)
	if (locale === "no") return no_offerdetail_table_creationdate2(inputs)
	if (locale === "pl") return pl_offerdetail_table_creationdate2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_creationdate2(inputs)
	if (locale === "pt") return pt_offerdetail_table_creationdate2(inputs)
	if (locale === "ro") return ro_offerdetail_table_creationdate2(inputs)
	if (locale === "fi") return fi_offerdetail_table_creationdate2(inputs)
	if (locale === "sv") return sv_offerdetail_table_creationdate2(inputs)
	if (locale === "vi") return vi_offerdetail_table_creationdate2(inputs)
	if (locale === "tr") return tr_offerdetail_table_creationdate2(inputs)
	if (locale === "cs") return cs_offerdetail_table_creationdate2(inputs)
	if (locale === "bg") return bg_offerdetail_table_creationdate2(inputs)
	if (locale === "ru") return ru_offerdetail_table_creationdate2(inputs)
	if (locale === "uk") return uk_offerdetail_table_creationdate2(inputs)
	if (locale === "ar") return ar_offerdetail_table_creationdate2(inputs)
	if (locale === "hi") return hi_offerdetail_table_creationdate2(inputs)
	if (locale === "th") return th_offerdetail_table_creationdate2(inputs)
	if (locale === "ja") return ja_offerdetail_table_creationdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_creationdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_creationdate2(inputs)
	return ko_offerdetail_table_creationdate2(inputs)
});
export { offerdetail_table_creationdate2 as "offerDetail.table.creationDate" }